/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiPersonDetailReviewsListParams } from './model/apiPersonDetailReviewsListParams';
import type { PaginatedPersonReviewDispatchList } from './model/paginatedPersonReviewDispatchList';

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailReviewsList = (
  opk: string,
  params?: ApiPersonDetailReviewsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedPersonReviewDispatchList>({
    url: `/api/v7/people/${opk}/reviews/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiPersonDetailReviewsListQueryKey = (
  opk?: string,
  params?: ApiPersonDetailReviewsListParams
) => {
  return [`/api/v7/people/${opk}/reviews/`, ...(params ? [params] : [])] as const;
};

export const getApiPersonDetailReviewsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiPersonDetailReviewsList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonDetailReviewsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonDetailReviewsList>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonDetailReviewsListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonDetailReviewsList>>> = ({
    signal,
  }) => apiPersonDetailReviewsList(opk, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiPersonDetailReviewsList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiPersonDetailReviewsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailReviewsList>>
>;
export type ApiPersonDetailReviewsListQueryError = ErrorType<unknown>;

export function useApiPersonDetailReviewsList<
  TData = Awaited<ReturnType<typeof apiPersonDetailReviewsList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonDetailReviewsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonDetailReviewsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiPersonDetailReviewsListQueryOptions(opk, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
